import { render, staticRenderFns } from "./EnvioRecoleccion.vue?vue&type=template&id=8fe7fb2a&scoped=true"
import script from "./EnvioRecoleccion.vue?vue&type=script&lang=js"
export * from "./EnvioRecoleccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe7fb2a",
  null
  
)

export default component.exports